import { render, staticRenderFns } from "./MainAccountBtn.vue?vue&type=template&id=06593afc&"
import script from "./MainAccountBtn.vue?vue&type=script&lang=js&"
export * from "./MainAccountBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports